import {customElement, queryAll} from "lit/decorators.js";
import Styles from "./newsSearchResultsTile.lit.scss";
import {html, type TemplateResult} from "lit";
import {ContentSearchImages} from "../contentSearchImages";
import {resolve} from "../../../../container";
import {keyed} from "lit/directives/keyed.js";
import type {FeedEntryTopic} from "../../feedEntry";
import {SearchTile} from "../searchTile";
import {ShadowHighlightContextAware} from "../../../../common/elements";
import type {Nullable} from "../../../../bootstrap/common/types";
import {EopNewsTag} from "../newsTag";

@customElement("eop-news-search-results-tile")
export class EopNewsSearchResultsTile extends ShadowHighlightContextAware(SearchTile) {

    public static readonly styles = Styles;

    @queryAll("eop-news-tag")
    private newsTags: NodeListOf<EopNewsTag>;

    public constructor(private images: ContentSearchImages = resolve(ContentSearchImages)) {
        super();
    }

    public render(): TemplateResult {
        return html`${keyed(this.entry.data.url + this.groupName, this.renderTile())}`;
    }

    protected renderImageElement(): Nullable<TemplateResult> {
        const functionalIcons = (!!this.entry.data.lightboxImageUrl && !this.entry.data.disclaimer) ? "lightbox-image-preview-icon" : "";
        return this.images.imageWithStaticAspectRatio(this.entry.getImageUrlFor4x3Purpose(), this.entry.data.imageAltText, functionalIcons);
    }

    protected renderTopicLinks(): Nullable<TemplateResult> {
        const feedEntryTopics = this.entry.data.topics;
        if (!feedEntryTopics || feedEntryTopics.isEmpty()) {
            return null;
        }

        return html`
            <div class="tags">${(this.renderTopicTags(feedEntryTopics))}</div>`;
    }

    private renderTopicTags(feedEntryTopics: FeedEntryTopic[]): TemplateResult[] {
        return feedEntryTopics.map(topic => html`
            <eop-news-tag
                    @mouseover=${this.removeHoverClass}
                    @mouseout=${this.addHoverClass}
                    .text=${topic.name}>
            </eop-news-tag>
        `);
    }

    protected showDescription(): boolean {
        return true;
    }

    protected headlineText(): string {
        return this.entry.data.headline ?? "---";
    }

    protected subHeadlineText(): string {
        return this.entry.data.subHeadline ?? "";
    }

    public lastFocusable(): HTMLElement {
        return Array.from(this.newsTags).last()?.focusableElement()
            ?? this.lastFocusableLink()
            ?? this.focusableTile();
    }
}